import { MyProfileSection } from './my-profile-section';
import { MovementsSection } from './movements-section';
import { MediaSection } from './media-section';
import { PresentationSection } from './presentation-section';
import { ProfessionalAssociationsSection } from './professional-associations-section';

export const MainUserInformation = () => {
  return (
    <div className="flex flex-col items-start gap-6">
      <MyProfileSection />
      <ProfessionalAssociationsSection />
      <MovementsSection />
      <MediaSection />
      <PresentationSection />
    </div>
  );
};
